<template>
  <div class="fillcontain">
    <head-top></head-top>
    <div class="table_container">
      <!--工具条-->
      <el-col :span="24" class="toolbar">
        <el-form :inline="true" :model="filters">
          <el-form-item>
            <el-form-item>
              <el-select v-model="value" placeholder="请选择">
                <el-option
                  v-for="item in categoryOptions"
                  :key="item.typeId"
                  :label="item.typeName"
                  :value="item.typeId">
                </el-option>
              </el-select>
            </el-form-item>
          </el-form-item>
          <el-form-item>
            <el-input v-model="filters.name" placeholder="课程名称"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary"  @click="searchQuery()">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="addFood()">新增</el-button>
          </el-form-item>
        </el-form>
      </el-col>
      <el-table
        :data="tableData"
        style="width: 100%">
        <el-table-column
          label="序号"
          type="index"
          width="70">
        </el-table-column>
        <el-table-column
          label="课程名称"
          prop="courseName">
        </el-table-column>
        <el-table-column
          label="子目录"
          prop="courseType">
        </el-table-column>
        <el-table-column
          label="时长"
          prop="timeLength">
        </el-table-column>
        <el-table-column
          label="作品赏析"
          prop="worksNum">
        </el-table-column>
        <el-table-column
          :formatter="formatDate"
          label="上传时间"
          prop="updateTime">
        </el-table-column>
        <el-table-column
          label="操作"
          fixed="right"
          width="180">
          <template slot-scope="scope">
            <el-button size="mini" v-if="scope.row.top!='0'" type="text" @click="getnoTop(scope.$index, scope.row)">取消置顶</el-button>
            <el-button size="mini" v-if="scope.row.top=='0'" type="text" @click="getTop(scope.$index, scope.row)">置顶</el-button>
            <el-button size="mini" type="text" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
            <el-button size="mini" type="text" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="Pagination">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="20"
          layout="total, prev, pager, next"
          :total="total">
        </el-pagination>
      </div>

    </div>
  </div>
</template>

<script>
  import headTop from '../components/headTop'
  import { getNoTop,getClassificationSub,getSearchQuery,chaindata,getDelcourse } from "../api/api"
  export default {
    inject: ['reload'],
    data () {
      return {
        value: '',
        options:[],
        filters: {
          name: ''
        },
        tableData: [],
        limit: 20,
        total: 0,
        currentPage: 1,
        dialogVisible:false,
        categoryOptions: [],
        selectedCategory: [],
      }
    },
    components: {
      headTop,
    },
    methods:{
      //时间戳转换
      formatDate:function (value){
        let dateee = new Date(value.uploadTime).toJSON();
        return new Date(+new Date(dateee)+8*3600*1000).toISOString().replace(/T/g,' ').replace(/\.[\d]{3}Z/,'')
      },
      handleCurrentChange(val) {
        this.currentPage = val
        this.searchQuerys()
      },
      // change(){
      //   this.currentPage = 1
      // },
      getCategory(){
        let params={
          category:2,
          pageNum:1,
          pageSize:200,
        };
        getClassificationSub(params).then(res=>{
          this.categoryOptions= res.pageInfo
          this.value = this.categoryOptions[0].typeId
          this.searchQuery()
        }).catch(error=>{
          console.log(error);
        })
      },
      searchQuery(){
        //  查询
        let params={
          category:2,
          pageNum:1,
          pageSize:this.limit,
          typeId:this.value,
          courseName:this.filters.name
        };
        getSearchQuery(params).then((res)=>{
          this.tableData = res.pageInfo
          this.total = res.total
          this.currentPage = res.pageNum
        }).catch(error=>{

        })
      },
      searchQuerys(){
        //  查询
        let params={
          category:2,
          pageNum:this.currentPage,
          pageSize:this.limit,
          typeId:this.value,
          courseName:this.filters.name
        };
        getSearchQuery(params).then((res)=>{
          this.tableData = res.pageInfo
          this.total = res.total
          this.currentPage = res.pageNum
        }).catch(error=>{

        })
      },
      handleEdit(index, row) {
        //编辑
        this.$router.push({
          path: 'modCourseification',
          query:{
            id:row.courseId,
            category:2
          }
        });
      },
      addFood(){
        //新增
        this.$router.push({
          path: 'newCourseification',
        });
      },
      handleDelete(index, row){
        //删除
        this.$confirm('确认删除该记录吗？', '提示', {
          // type: 'warning'
        }).then(() => {
          let params={
            courseId:row.courseId,
            operationId:JSON.parse(sessionStorage.getItem('user')).id,
            category:2
          };
          getDelcourse(params).then(res=>{
            if (res.state == true) {
              this.$message({
                type: 'success',
                message: res.msg
              });
              this.tableData.splice(index, 1);
            }else{
              throw new Error(res.message)
            }
          }).catch(error=>{
            this.$message({
              type: 'error',
              message: res.msg
            });
          })
        })
      },
      getTop(index, row){
        //  置顶
        let params = ({
          courseId:row.courseId,
          operationId:JSON.parse(sessionStorage.getItem('user')).id
        })
        chaindata(params).then(res=>{
          if (typeof (res) == 'number') {
            this.$message({
              type: 'success',
              message: '置顶成功'
            });
            this.searchQuerys()
            let timer = setInterval(()=>{
              row.top = res;
            },500)
          }else{
            this.$message({
              type: 'error',
              message: '置顶失败'
            });
          }
        }).catch(error=> {
          console.log(error)
        })
      },
      getnoTop(index, row){
        //  取消置顶
        let params = ({
          courseId:row.courseId,
          top:0,
          operationId:JSON.parse(sessionStorage.getItem('user')).id,
        })
        getNoTop(params).then(res=>{
          if (res.state = true) {
            this.$message({
              type: 'success',
              message: '取消置顶成功'
            });
            row.top = 0
            this.searchQuerys()
          }else{
            this.$message({
              type: 'error',
              message: '取消置顶失败'
            });
          }
        }).catch(error=> {
          console.log(error)
        })
      }
    },
    activated(){
      this.getCategory()
    },
  }
</script>

<style lang="less">
  @import '../style/mixin';
  .demo-table-expand {
    font-size: 0;
  }
  .demo-table-expand label {
    width: 90px;
    color: #99a9bf;
  }
  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
  }
  .Pagination{
    display: flex;
    justify-content: flex-start;
    margin-top: 20px;
    float:right;
  }
</style>




// WEBPACK FOOTER //
// src/page/addShop.vue